
import { Component, PropSync, Vue } from 'nuxt-property-decorator'
import { $api } from '~/plugins/axios'
import { B2bFormRequestPayload } from '~/services/common.service'
import { AlButton } from '~/components/ui'

const EMPLOYEES_OPTIONS = ['1-5', '6-20', '21-50', '>50']

@Component({
  components: {
    AlButton,
  },
})
export default class B2bForm extends Vue {
  @PropSync('isLoading', { required: true, default: false, type: Boolean })
  loading!: boolean

  private form: B2bFormRequestPayload = {
    company_name: '',
    contact_person: '',
    phone_number: '',
    email: '',
    number_of_employees: EMPLOYEES_OPTIONS[0],
    purpose: '',
    comment: '',
    token: '',
  }

  get employeers () {
    return EMPLOYEES_OPTIONS
  }

  get purposes () {
    return [
      this.$t('b2b.form.purposeOptions.mobilePhoneContracts') as string,
      this.$t('b2b.form.purposeOptions.internetTvContracts') as string,
      this.$t('b2b.form.purposeOptions.mobileAndInternetContracts') as string,
      this.$t('b2b.form.purposeOptions.otherTelecomServices') as string,
    ]
  }

  created () {
    this.form.purpose = this.purposes[0]
  }

  async mounted () {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e)
    }
  }

  beforeDestroy () {
    this.$recaptcha.destroy()
  }

  async submit () {
    if (!(await this.$validator.validate())) {
      return
    }

    this.loading = true

    let token

    try {
      token = await this.$recaptcha.execute('b2b')
    } catch (error) {
      this.loading = false
      throw new Error('captcha b2b error:' + error)
    }

    try {
      await $api.CommonService.submitB2bForm({ ...this.form, token })
      this.$analytics.GTM.trackRaw({
        eventCategory: 'b2b-form',
        eventAction: 'form-submission',
        eventLabel: `${this.form.company_name}|${this.form.number_of_employees}`,
      })
      this.$emit('submitted')
      this.reset()
    } finally {
      this.loading = false
    }
  }

  reset () {
    this.form = {
      company_name: '',
      contact_person: '',
      phone_number: '',
      email: '',
      number_of_employees: this.employeers[0],
      purpose: this.purposes[0],
      comment: '',
      token: '',
    }
    this.$validator.reset()
  }
}
